// État du réseau (TRV-07, CMP-NetworkStatusBar). Ne jamais afficher « synchronisé » à tort : hors ligne = hors ligne.
import { useSyncExternalStore } from 'react';

function subscribe(onChange: () => void): () => void {
  window.addEventListener('online', onChange);
  window.addEventListener('offline', onChange);
  return () => {
    window.removeEventListener('online', onChange);
    window.removeEventListener('offline', onChange);
  };
}

export function useOnlineStatus(): boolean {
  return useSyncExternalStore(subscribe, () => navigator.onLine, () => true);
}

/** Économiseur de données (TRV-09) : pas de préchargement si l'utilisateur l'a demandé ou sur réseau 2G. */
export function prefersDataSaving(): boolean {
  const connection = (navigator as Navigator & { connection?: { saveData?: boolean; effectiveType?: string } }).connection;
  return connection?.saveData === true || /(^|-)2g$/.test(connection?.effectiveType ?? '');
}
